module.exports = __webpack_public_path__ + "static/media/resumepic.4cd24c59.jpg";